import { combineReducers, configureStore } from '@reduxjs/toolkit';

import usersReducer from './features/usersSlice';
import snackbarReducer from './features/snackbarSlice';
import itemsReducer from './features/items/itemsSlice';
import authorsReducer from './features/authors/authorsSlice';
import listsReducer from './features/lists/listsSlice';
import tagsReducer from './features/tags/tagsSlice';
import sitesReducer from './features/sites/sitesSlice';
import pendingReducer, { pendingListener } from './features/pending/pendingSlice';
import contextReducer from './features/context/contextSlice';
import { createApiServices } from '../api';

const combinedReducer = combineReducers({
  users: usersReducer,
  snackbar: snackbarReducer,
  items: itemsReducer,
  authors: authorsReducer,
  lists: listsReducer,
  tags: tagsReducer,
  sites: sitesReducer,
  pending: pendingReducer,
  context: contextReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'users/logoutUser/fulfilled') {
    return combinedReducer(undefined, action);
  }

  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const api = createApiServices(() => store.getState().users.authToken);
    return getDefaultMiddleware({
      thunk: {
        extraArgument: api,
      },
    }).prepend(pendingListener.middleware);
  },
});

export default store;
